import React from 'react'
import { Stack } from '@mui/material'
import { SPACING } from '../../typography'
import { ReignStack } from './stacks'

export const ReignItem = props => {
  const { children = null } = props
  return (
    <>
      <Stack spacing={SPACING} sx={{ minWidth: 300 }}>
        <ReignStack {...props} />
      </Stack>
      {children}
    </>
  )
}
